import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SectionTitle = styled.h4`
  font-size: 13px;
  font-weight: 600;
  color: #808080;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin: 0px;
`

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 4px;
`

/*
  O bloco da revisão manual. Destacado porque a escolha feita aqui é irreversível do ponto de
  vista do sistema: marcar "a transferência saiu" dá quitação a um recebível, e não há como
  desfazer isso por tela.
*/
export const ReviewCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 13px 15px;
  border-radius: 15px;
  background-color: #FFF6DC;
  border: 1px solid #FFE08A;

  p {
    margin: 0px;
    font-size: 13px;
    line-height: 1.45;
    color: #8A6100;
  }
`

export const ErrorCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 11px 13px;
  border-radius: 15px;
  background-color: #FFF0F0;
  border: 1px solid #FFCFCF;

  span {
    font-size: 12px;
    color: #A34141;
  }

  p {
    margin: 0px;
    font-size: 13px;
    line-height: 1.4;
    color: #252525;
    word-break: break-word;
  }
`
